import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Global Types
import { AppState } from 'services/types';
import { SchemaEntityTypeId } from 'services/schemas/types';

// Global Components
import EntityDropdownField from 'components/EntityDropdownField';

// Global Selectors
import { selectSpraySchemaEntityTypeId } from 'services/schemas/selectors';

interface OwnProps {
    name: string;
    validate?: any;
    useCompositeKey?: boolean;
    disabled?: boolean;
}

interface ConnectedProps {
    spraySchemaEntityTypeId?: SchemaEntityTypeId;
}

type Props = OwnProps & ConnectedProps;

export class SpraySchemaEntityTypeEntityDropdownField extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const {
            name,
            validate,
            useCompositeKey,
            spraySchemaEntityTypeId,
            disabled
        } = this.props;

        if (!spraySchemaEntityTypeId) {
            return null;
        }

        return (
            <EntityDropdownField
                entityTypeId={spraySchemaEntityTypeId}
                name={name}
                validate={validate}
                useCompositeKey={useCompositeKey}
                disabled={disabled}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    spraySchemaEntityTypeId: selectSpraySchemaEntityTypeId
});

export default connect(mapStateToProps)(
    SpraySchemaEntityTypeEntityDropdownField
);
